import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconH1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconH1"><Path fillRule="evenodd" clipRule="evenodd" d="M4 4V11H12V4H14V20H12V13H4V20H2V4H4Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M20.0859 10H22.0002V20H20.0002V12.9142L18.0002 14.9142L16.5859 13.5L20.0859 10Z" fill="currentColor"/></CentralIconBase>;
});

export default IconH1;
